import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-631b04ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status-parameter__description" }

import { PropType } from 'vue';
import GetListStatusResponseItemModel from '../models/GetListStatusResponseItemModel';
import { InformationCircleIcon } from 'tir-style-system/icons/outline';
import { TirPmTooltipElement } from 'tir-pm-tooltip-element';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'status-parameter',
  props: {
  /**Опции статуса */
  options: { type: Object as PropType<GetListStatusResponseItemModel>, required: true },
},
  emits: ["selectStatus"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Выбрать статус */
const selectStatus = () => {
  emit('selectStatus');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "status-parameter__block",
    onClick: selectStatus
  }, [
    _createElementVNode("div", {
      class: "status-parameter",
      style: _normalizeStyle({ borderColor: __props.options.Color })
    }, [
      _createElementVNode("div", {
        class: "status-parameter__bg",
        style: _normalizeStyle({ backgroundColor: __props.options.Color })
      }, null, 4),
      _createElementVNode("div", {
        class: "status-parameter__indicator",
        style: _normalizeStyle({ backgroundColor: __props.options.Color })
      }, null, 4),
      _createElementVNode("span", {
        class: "status-parameter__text",
        style: _normalizeStyle({ color: __props.options.Color })
      }, _toDisplayString(__props.options.Name), 5)
    ], 4),
    (__props.options.Description)
      ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { key: 0 }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(__props.options.Description), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(InformationCircleIcon), { class: "status-parameter__icon" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})